/**
 * Whether a media-recovery attempt should be COUNTED when there is nothing
 * published to repair.
 *
 * Pure and React-free so the rule can be unit-tested with `node --test`.
 *
 * `recover()` bails early when the local participant has neither a microphone nor
 * a camera track — there is no dead device to re-open, and forcing a capture would
 * be an unasked-for permission prompt. But a person who pressed "Fix now" DID try,
 * and the recovery feedback counts `recovery.attempts`; if that press did not
 * register, a session that lost every track would lose feedback for the manual attempt. So a
 * manual attempt with no tracks still counts (without touching the device), while
 * an automatic trigger with no tracks stays a silent no-op. When any track exists,
 * the normal recovery path runs and counts its own attempt — this returns false.
 */
export interface ManualAttemptGate {
  /** The RecoveryReason; only 'manual' is a deliberate human press. */
  reason: string
  hasAudio: boolean
  hasVideo: boolean
}

export function shouldCountManualAttempt({
  reason,
  hasAudio,
  hasVideo,
}: ManualAttemptGate): boolean {
  return reason === 'manual' && !hasAudio && !hasVideo
}
